import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { postAnalytics } from "../../../../../PatientComponents/analytics";
import PropTypes from "prop-types";
import { useState } from "react";
import { usePatientFacing } from "../../../../flow/patientFacing/hooks/usePatientFacing";

function SingleQuestion({ questionKey, onAnswer, show, keyPrefix = "" }) {
  const { t } = useTranslation();
  const { getEventDataLocal } = usePatientFacing();
  const event = getEventDataLocal();
  const caseId = event?.Case?.id;
  const [answer, setAnswer] = useState("");
  console.log('[SingleQuestion] render:', { questionKey, show, caseId });

  const handleFeedback = (answer) => () => {
    if (!caseId) return;
    postAnalytics(caseId, `satisfaction-question-${questionKey}`, answer);

    setAnswer(answer);
    if (onAnswer) onAnswer();
  };

  return (
    <FeedBackWrapper id="FeedBackWrapper" show={show}>
      <FeedbackTitle id="FeedbackTitle">
        {t(`${keyPrefix}Satisfaction-question-${questionKey}`)}
      </FeedbackTitle>
      <Answers id="Answers">
        <Answer
          id="AnswerYes"
          onClick={handleFeedback("Yes")}
          checked={answer === "Yes"}
        >
          {t("Yes")}
        </Answer>
        <Answer
          id="AnswerNo"
          onClick={handleFeedback("No")}
          checked={answer === "No"}
        >
          {t("No")}
        </Answer>
      </Answers>
    </FeedBackWrapper>
  );
}

export default SingleQuestion;

SingleQuestion.propTypes = {
  questionKey: PropTypes.string.isRequired,
  onAnswer: PropTypes.func,
  show: PropTypes.bool,
  keyPrefix: PropTypes.string,
};

const FeedBackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  opacity: ${({ show }) => (show ? 1 : 0)};
  height: ${({ show }) => (show ? "auto" : 0)};
  transition: opacity 200ms linear;
  padding-inline: var(--screen-texts-padding);
  overflow: hidden;
`;

const FeedbackTitle = styled.div`
  text-align: start;
  font-size: 1.125rem;
  font-weight: 400;
`;

const Answers = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.938rem;
`;
const Answer = styled.button`
  border: 2px solid #84a4fc;
  border-radius: 20px;
  color: #84a4fc;
  background-color: transparent;
  font-family: "Abraham", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.2839rem 1.9rem;
  ${({ checked }) =>
    checked &&
    css`
      color: #fff;
      background-color: #84a4fc;
    `}
`;
